import { z } from 'zod';
import { TransferOrderCancelReason } from '../../constants/index.js';
import { TRANSFER_ORDER_CONSTRAINTS } from './constraints.js';
import { lowercasedRequiredUuidString } from './lowercased-required-uuid-string.js';
export const cancelTransferOrderInputSchema = z
    .object({
    id: lowercasedRequiredUuidString('Transfer order id is required.', 'Invalid transfer order id.'),
    reasonId: z.enum(TransferOrderCancelReason, 'Choose a reason.'),
    note: z
        .string()
        .max(TRANSFER_ORDER_CONSTRAINTS.note.maxLength, `Note must be ${TRANSFER_ORDER_CONSTRAINTS.note.maxLength} characters or fewer.`)
        .transform((value) => value.trim() || null)
        .nullish(),
})
    .superRefine((values, context) => {
    if (values.reasonId === TransferOrderCancelReason.OTHER && !values.note) {
        context.addIssue({
            code: 'custom',
            path: ['note'],
            message: 'Add a note when the reason is Other.',
        });
    }
});
//# sourceMappingURL=cancel-input.js.map